const getters = {
  callStatus: state => state.callStatus,
  permissions: state => state.user.permissions,
  sidebarRouters:state => state.permission.sidebarRouters,
  strategyList:state => state.strategy.listData,
}
export default getters
